var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('p',{ref:"linkValue"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.hasCopyButton)?_c('div',{staticClass:"icon-container"},[(_vm.isCopied)?_c('i',{staticClass:"icon-check-circle"}):_c('i',{staticClass:"icon-copy",on:{"click":_vm.copy}})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }